export default {"src":"/_next/static/media/made-in-NY.3cac1ac3.svg","height":78,"width":78,"blurWidth":0,"blurHeight":0};